<template>
  <div class="work-data_block">
    <p class="large_label">案件情報</p>
    <TableBox :is-with-header="false" :table-contents="workData"/>

    <p class="large_label">使用ソフトウェア</p>
    <TableBox :is-with-header="true" :table-contents="parentData(work.softwares, {dt: '使用ソフトウェア', dd: 'バージョン'})"/>

    <p class="large_label">所持スキル</p>
    <TableBox :is-with-header="true" :table-contents="parentData(work.requiredSkills, {dt: '所持スキル', dd: '備考'})"/>

    <p v-if="work.documentUrls" class="large_label">添付ファイル</p>
    <FileDownloaderBox v-for="(documentUrl, index) in work.documentUrls" :documentUrl="documentUrl" :key="index"/>
  </div>
</template>

<script>
  import moment from "moment";
  import TableBox from "@/components/molecules/box/TableBox";
  import STATUSES from "@/assets/js/constants/statuses";
  import FileDownloaderBox from "@/components/molecules/box/form/FileDownloaderBox";

  export default {
    name: "WorkDataTable",

    components: {FileDownloaderBox, TableBox},

    props: {
      work: {
        type: Object,
        required: true
      },
    },

    computed: {
      workData() {
        const result = {};
        result.title = {dt: 'タイトル', dd: this.work.title};
        result.description = {dt: '詳細', dd: this.work.description};

        if (this.work.status) {
          result.status = {dt: 'ステータス', dd: this.displayStatus(this.work.status)};
        }

        result.estimationOfWorkTime = {dt: '見積時間', dd: this.work.estimationOfWorkTime ? `${this.work.estimationOfWorkTime}分` : ''};
        result.deadline = {
          dt: '期限',
          dd: !this.work.deadline ? '' : moment.unix(this.work.deadline.seconds).format('YYYY/MM/DD HH:mm')
        };
        result.rewards = {dt: '報酬', dd: this.work.rewards ? `${this.work.rewards}円` : ''};

        if (this.work.requiredScores) {
          result.requiredScores = {dt: '作業者のクオリティ', dd: this.work.requiredScores};
        }

        return result;
      },
    },

    beforeCreate() {
      Object.assign(this, {STATUSES});
    },

    methods: {
      parentData(parents, header) {
        if (!parents) return {};
        const result = {
          header: header
        };

        for (let [parent_key] of Object.entries(parents)) {
          if (parents[parent_key].isSelected) {
            result[parent_key] = {
              dt: parents[parent_key].displayName,
              dd: ''
            };

            for (let [child_key] of Object.entries(parents[parent_key].children)) {
              if (parents[parent_key].children[child_key].isSelected) {
                if (result[parent_key]['dd'] !== '') result[parent_key]['dd'] = result[parent_key]['dd'] + '\n';
                result[parent_key]['dd'] = result[parent_key]['dd'] + `・${parents[parent_key].children[child_key].displayName}`;
              }
            }
          }
        }

        return result;
      },

      displayStatus(status) {
        let result = '';
        for (let [key] of Object.entries(STATUSES)) {
          if (STATUSES[key].name === status) {
            result = STATUSES[key].displayName
          }
        }
        return result;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .work-data_block {
    .large_label {
      margin: 4rem 0 2rem 0;
    }

    .table_box {
      margin: 2rem 0;
      width: 100%;
    }

    .yellow-ellipse_button {
      justify-self: center;
    }
  }
</style>